import { __decorate, __metadata } from "tslib";
import { Command } from '@ftr/bus-messages';
import { IsNumber } from 'class-validator';
export class SealingRequest extends Command {
    /**
     * @param recordingId The recording id to seal against
     * @param seal Whether this is a request to seal or unseal
     * @param start The second of the day to start sealing/unsealing
     * @param end The second of the day to end sealing/unsealing
     */
    constructor(recordingId, seal, start, end) {
        super();
        this.recordingId = recordingId;
        this.seal = seal;
        this.$name = SealingRequest.NAME;
        this.$version = 0;
        this.start = start;
        this.end = end;
    }
}
SealingRequest.NAME = 'ftr-recording/SealingRequest';
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], SealingRequest.prototype, "start", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], SealingRequest.prototype, "end", void 0);
